module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_8.f6660bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_8.png
// module id = pTwF
// module chunks = 0